import request from "../../../utils/request";

// 列表
export const getLotteryPolymerizeList = (params) => {
  return request({
    method: "GET",
    path: "/admin-management/getLotteryPolymerizeList",
    params,
  });
};

// 获取活动参与人员
export const getSpecialUserList = (params) => {
  return request({
    method: "GET",
    path: "/admin-management/getSpecialUserList",
    params,
  });
};

// 保存活动预参与人员
export const joinWithSpecialUsers = (params) => {
  return request({
    method: "POST",
    path: "/admin-management/joinWithSpecialUsers",
    params,
  });
};